// @ts-check
// Região viva das novidades (contrato 08-contrato-novidades.md, seção 6): o balão e o cartão não roubam o foco, então
// quem usa leitor de tela ouve uma vez por sessão onde o aviso está. Montada vazia no shell, que também liga o relógio da
// abertura automática.
import { html } from 'htm/preact';
import { useEffect, useState } from 'preact/hooks';
import { useReleaseNotesAutoOpenClock, useReleaseNotesSurface } from './release-notes-state.js';
import { t } from '../../i18n/index.js';

/** Superfícies já anunciadas nesta sessão: a mesma não é lida de novo ao trocar de tela. */
const announcedSurfaces = new Set();

export function ReleaseNotesAnnouncer() {
  useReleaseNotesAutoOpenClock();
  const { surface, announcement } = useReleaseNotesSurface();
  const [message, setMessage] = useState('');
  const version = announcement?.version ?? null;
  useEffect(() => {
    if (!version) {
      setMessage('');
      return;
    }
    if (!surface || announcedSurfaces.has(surface)) return;
    announcedSurfaces.add(surface);
    setMessage(t(surface === 'balloon' ? 'releaseNotes.announcer.drawer' : 'releaseNotes.announcer.card', { version }));
  }, [surface, version]);
  return html`<div class="release-notes-visually-hidden" aria-live="polite" aria-atomic="true">${message}</div>`;
}
